import { STORAGE_MEDIA } from '../config/storage';

export const founderNoteContent = {
  label: "FOUNDER'S NOTE",
  heading: "More Than Skincare.\nA Promise From Our Heart.",
  body: [
    "Every product we create begins with one simple belief —",
    "Skincare should never feel complicated.",
    "It should feel comforting, effective, and something you genuinely look forward to every day.",
    "At May Secret, every formula is chosen with care, inspired by Korean skincare philosophy, and selected to help you feel confident in your own skin.",
    "We are committed to bringing together quality, simplicity, and trust, because your skincare journey deserves products that truly work.",
    "Thank you for allowing us to be a small part of your daily routine.",
    "With gratitude,"
  ],
  signature: "Adv. Prasanna",
  role: "Founder & Brand Director",
  imageUrl: STORAGE_MEDIA.hero.owner.src,
  values: [
    {
      icon: "✨",
      title: "Korean Beauty Inspired",
      description: "Crafted with timeless skincare philosophy."
    },
    {
      icon: "🌿",
      title: "Carefully Selected Ingredients",
      description: "Every ingredient is chosen with purpose."
    },
    {
      icon: "❤️",
      title: "Customer First",
      description: "Every decision begins with your skincare journey."
    },
    {
      icon: "🛡️",
      title: "Quality You Can Trust",
      description: "Premium products with uncompromising standards."
    }
  ]
};
